import * as PouchDB from 'pouchdb/dist/pouchdb';
import upsert from 'pouchdb-upsert';
import { DbEntry } from '../../model/db-entry.model';
import { Injectable } from '@angular/core';
import { TimeUtils } from '../../../../utils/time.utils';

@Injectable()
export class StorageServiceProvider {
  db: any = null;

  constructor() {
    PouchDB.plugin(upsert);
    this.init();
  }

  private init() {
    this.db = new PouchDB('sellions_database', {
      adapter: 'idb',
      size: 20,
      androidDatabaseImplementation: 2,
      revs_limit: 1,
      auto_compaction: true,
    });
  }

  public get(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.db
        .get(id)
        .then((response: { value: any }) => {
          resolve(response.value);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  }

  public set(key: string, value: string): Promise<void> {
    return this.db
      .upsert(key, (document: { value: string }) => {
        document.value = value;
        return document;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public setObject(key: string, value: any): Promise<any> {
    return this.db
      .upsert(key, (document: { value: string }) => {
        document.value = JSON.stringify(value);
        return document;
      })
      .catch((err) => console.error(err));
  }

  public setBulkObject(values: any[], keyFormulationFunction?: (value: any) => string): Promise<void> {
    return this.db
      .bulkDocs(
        values.map((value) => {
          return { value, _id: keyFormulationFunction(value) };
        }),
      )
      .catch((err: any) => console.error(err));
  }

  public getObject(key: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.db
        .get(key)
        .then((document: { value: string }) => {
          if (document.value) {
            resolve(JSON.parse(document.value));
          } else {
            resolve(null);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // fetchFunc has to return an Observable
  public getOrFetch(key: string, fetchFunc: Function, timeout: number): Promise<string> {
    return this.get(key)
      .then((dbEntryJson: string) => {
        const dbEntry: DbEntry = JSON.parse(dbEntryJson);

        if (TimeUtils.getUnixTimestamp() - dbEntry.lastModTime >= timeout) {
          return fetchFunc().toPromise();
        } else {
          return dbEntry.value;
        }
      })
      .catch(() => fetchFunc().toPromise());
  }

  public flushCache() {
    this.db
      .query((doc: { value: { lastModTime: any } }, emit: Function) => doc.value && doc.value.lastModTime != null && emit(doc))
      .then((val: { rows: any[] }) => val.rows.forEach((cell) => this.db.remove(cell).catch(() => {})));
  }

  public clearStorage(): Promise<any> {
    return this.db.destroy().then(() => this.init());
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/storage-service/storage-service.ts